// eslint-disable-next-line
export const UPDATE_SERVER_STATUS = 'SYNC_SERVERSTATUSES_UPDATE_SERVER_STATUS'



// WEBPACK FOOTER //
// ./src/features/Sync/data/serverStatuses/constants.js